import React, { Component } from "react";
import { connect } from "react-redux";
import Loadable from "react-loadable";
import {
  updateFieldsCheckInsurance,
  scanQrCodeInsuranceSuccess,
  resetStatusScanQrCodeInsurance
} from "~/store/patient/patientAction";
import { setPatientInfo } from "~/store/patientForm/patientFormAction";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import { partnerInfo } from "~/configs/partnerDetails";
import { get, find } from "lodash";

const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const CheckBHYTPageMobile = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "mobile" */ "~/components/mobile/pages/CheckBHYT"
    ),
  loading: LoadableLoading
});
const CheckBHYTPageDesktop = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "desktop" */ "~/components/mobile/pages/CheckBHYT"
    ),
  loading: LoadableLoading
});

class CheckBHYT extends Component {
  componentDidMount() {
    this.props.resetStatusScanQrCodeInsurance();
  }

  render() {
    const { device } = this.props;
    return (
      <React.Fragment>
        {device === "mobile" ? (
          <CheckBHYTPageMobile {...this.props} />
        ) : (
          <CheckBHYTPageDesktop {...this.props} />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    patient: { formCheckInsurance }
  } = state;
  return {
    device: type,
    formCheckInsurance
  };
};

const CheckBHYTHelmet = withTitle({
  component: CheckBHYT,
  title: `${hospitalName.value} | Check BHYT`
});

export default connect(mapStateToProps, {
  updateFieldsCheckInsurance,
  scanQrCodeInsuranceSuccess,
  resetStatusScanQrCodeInsurance,
  setPatientInfo
})(CheckBHYTHelmet);
